module.exports = __webpack_public_path__ + "static/img/172463884136586479142871.05bcfd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/picture/20240826/172463884136586479142871.png
// module id = 8NPb
// module chunks = 7